import serviceImage from "../assets/images/service.jpg";

const services = [
  {
    id: 1,
    title: "Deep cleaning for apartment",
    price: 500,
    duration: "2 hours",
    discount: "10% discount on coupon code",
    image: serviceImage,
    category: "Cleaning",
  },
  {
    id: 2,
    title: "Office deep cleaning",
    price: 800,
    duration: "4 hours",
    discount: "5% discount on coupon code",
    image: serviceImage,
    category: "Cleaning",
  },
  {
    id: 3,
    title: "Car washing & detailing",
    price: 150,
    duration: "1 hour",
    discount: null,
    image: serviceImage,
    category: "Automotive",
  },
  {
    id: 4,
    title: "Garden & lawn maintenance",
    price: 200,
    duration: "3 hours",
    discount: "15% discount on coupon code",
    image: serviceImage,
    category: "Outdoor",
  },
  {
    id: 5,
    title: "Home painting service",
    price: 1200,
    duration: "8 hours",
    discount: null,
    image: serviceImage,
    category: "Renovation",
  },
  {
    id: 6,
    title: "Plumbing repair & installation",
    price: 350,
    duration: "2 hours",
    discount: "10% discount on coupon code",
    image: serviceImage,
    category: "Repair",
  },
];

export default services;
